"use strict";

exports.__esModule = true;
exports.colourIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const colourIcon = Component => {
  return (0, _styledComponents.default)(Component)`
        .svg-fill-primary { 
            fill: ${({
    theme
  }) => theme.colors.colourIcon.primary};
        };
        .svg-stroke-primary {
            stroke: ${({
    theme
  }) => theme.colors.colourIcon.primary};
        };
        .svg-fill-secondary {
            fill: ${({
    theme
  }) => theme.colors.colourIcon.secondary};
        };
        .svg-stroke-secondary {
            stroke: ${({
    theme
  }) => theme.colors.colourIcon.secondary};
        };
        .svg-fill-danger {
            fill: ${({
    theme
  }) => theme.colors.danger};
        };
        .svg-stroke-danger {
            stroke: ${({
    theme
  }) => theme.colors.danger};
        };
    `;
};

exports.colourIcon = colourIcon;